import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { useWebAppGetFragmentSocialUploadsByFragmentId } from '@mi-front/api-v2';

/** Stable empty map for when there is no data, to avoid unnecessary re-renders. */
const EMPTY_UPLOADS_BY_PLATFORM = new Map<string, FragmentSocialUploadItemDto[]>();

/**
 * Maps BFF response to uploads grouped by platform (Map<platformId, uploads[]>).
 * Used as React Query select so the query only re-renders when this derived value is used.
 */
function selectUploadsByPlatform(
  raw: { uploads?: FragmentSocialUploadItemDto[] } | undefined,
): Map<string, FragmentSocialUploadItemDto[]> {
  if (!raw?.uploads?.length) return EMPTY_UPLOADS_BY_PLATFORM;
  const map = new Map<string, FragmentSocialUploadItemDto[]>();
  for (const upload of raw.uploads) {
    const platform = upload.platform.toUpperCase();
    const list = map.get(platform) ?? [];
    list.push(upload);
    map.set(platform, list);
  }
  return map;
}

/**
 * Fetches all social uploads for a fragment from the BFF and groups them by platform.
 * Uses React Query select so the returned data is the grouped Map directly.
 */
export function useFragmentSocialUploadsQuery(fragmentId: string | undefined) {
  const query = useWebAppGetFragmentSocialUploadsByFragmentId(fragmentId ?? '', {
    query: {
      enabled: !!fragmentId,
      select: selectUploadsByPlatform,
    },
  });

  return query;
}
